
export const MENU = {
  HOME: 'home',
  BROADCAST: 'broadcast',
  LIVE: 'live',
  MOVIE: 'movie',
  GLOBAL: 'global',
  PLAYY: 'palyy',
  CLIP: 'clip',
  LIST: 'list'
}

export const GNB_MENU_LIST = [
  MENU.HOME,
  MENU.BROADCAST,
  MENU.LIVE,
  MENU.MOVIE,
  MENU.GLOBAL,
  MENU.PLAYY
]

export const UI_CODE = {
  HOME: 'GN1',
  BROADCAST: 'GN2',
  LIVE: 'GN3',
  MOVIE: 'GN4',
  GLOBAL: 'GN12',
  PLAYY: 'GN5',
  CLIP: 'GN6'
}

export const EVENT_TYPE = {
  ON_CLICK: 'on-click',
  ON_CONTENT: 'on-content',
  ON_DISPLAY: 'on-display',
  ON_VIEW_MORE: 'on-viewmore',
  ON_NAVIGATION: 'on-navigation',
  ON_MOVE_TAB: 'on-movetab'
}

export const MULTI_SECTION_LIST_ACTIONS = {
  FETCH: 'FETCH_MULTI_SECTION_LIST',
  SET: 'SET_MULTI_SECTION_LIST'
}

export const SEARCH_TAB_LIST = [
  { title: '전체', url: '전체', type: 'all', isBeta: false },
  { title: '프로그램', url: '프로그램', type: 'program', isBeta: false },
  { title: '에피소드', url: 'VOD', type: 'vod', isBeta: false },
  { title: 'LIVE', url: 'LIVE', type: 'live', isBeta: false },
  { title: '영화', url: '영화', type: 'movie', isBeta: false },
  { title: '에디터Pick', url: '에디터Pick', type: 'theme', isBeta: false },
  { title: '고객지원', url: '고객지원', type: 'customer', isBeta: false }
]

export const SET_CURRENT_MENU = 'SET_CURRENT_MENU'
export const SET_CURRENT_GNB = 'SET_CURRENT_GNB'
export const SHOW_LOADING_PROGRESS = 'SHOW_LOADING_PROGRESS'
export const HIDE_LOADING_PROGRESS = 'HIDE_LOADING_PROGRESS'

export const SEARCH_HISTORY_LOCAL_STORAGE_KEY = 'search-history'

export const CLOSE_SEARCH_POPUP_EVENT = '$CLOSE_SEARCH_POPUP'
export const OPEN_SEARCH_POPUP_EVENT = '$OPEN_SEARCH_POPUP'

export const CATEGORY_BROAD_CAST = 'vodgenre'
export const CATEGORY_MOVIE = 'moviegenre'

export const UPDATE_MY_POOQ_CONTENT = 'update_mypooq_contents'
export const UPDATE_PAGING_CONTENT = 'update_paging_contents'
export const UPDATE_MAIN_LAYOUT_CONTENT = 'update_main_layout_content'
export const UPDATE_EVENT_LAYOUT_CONTENT = 'update_event_layout_content'
export const UPDATE_EVENT_LIST_CONTENT = 'update_event_list_content'
export const UPDATE_SEARCH_CONTENT = 'update_search_content'
export const UPDATE_VOD_ALL_LIST_CONTENT = 'update_vod_all_list_content'
export const UPDATE_PLAYER_INFO = 'update_player_info'
export const ON_DISPLAY_BAND = 'on_display_multi_band'
export const ON_CLICK_CELL = 'on_click_cell'
export const DOMAIN = location.hostname.replace('www.', '')
export const GENRE_CODE_GLOBAL_DRAMA = '09'

export const SERVICE_LOCATION_KEY = 'service_location_key'
export const SERVICE_LOCATION_AMAZON = 'aws'
export const SERVICE_LOCATION_AZURE = 'azure'
export const SERVICE_LOCATION_AZURE_FOR_PLAYER = 'az'
export const UPDATE_JSON_URL = 'https://pooq3-static-json.pooq.co.kr/service/update/update_pc.json'
export const UPDATE_JSON_URL_TEST = 'https://pooq3-static-json.pooq.co.kr/serviceTest/updateTest/update_pc.json'
export const EMERGENCY_JSON_URL = 'https://pooq3-static-json.pooq.co.kr/service/update/update_pc.json'
export const EMERGENCY_JSON_URL_TEST = 'https://pooq3-static-json.pooq.co.kr/serviceTest/updateTest/update_pc.json'

const today = new Date()
export const CONFIRM_EMERGENCY = '' + today.getFullYear() + (today.getMonth() + 1) + today.getDate()
